import { render, staticRenderFns } from "./SecondYear.vue?vue&type=template&id=1e244939&"
import script from "./SecondYear.vue?vue&type=script&lang=js&"
export * from "./SecondYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports